import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cover from "./components/Cover";
import Body from "./components/Body";
import './index.css'
function App() {
  return (
    <div className="App">
      <Cover />
      <Body />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js